import { animate, keyframes, query, stagger, style, transition, trigger } from '@angular/animations';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, NgModule, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { environment } from '@environment';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';
import { trackEventWithAtInternet } from '@wizbii/tracking';
import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-home-b-hero',
  templateUrl: './home-b-hero.component.html',
  styleUrls: ['./home-b-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('imagesAnimation', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(
          ':enter',
          stagger('300ms', [
            animate(
              '1.4s ease-in-out',
              keyframes([
                style({ opacity: 0, transform: 'translateX(-100%)', offset: 0 }),
                style({ opacity: 0.1, transform: 'translateX(0)', offset: 0.3 }),
                style({ opacity: 0.5, offset: 0.6 }),
                style({ opacity: 1, offset: 1.0 }),
              ])
            ),
          ]),
          { optional: true }
        ),
      ]),
    ]),
  ],
})
export class HomeBHeroComponent implements OnInit {
  @Output() onGoToEmployersSectionClick = new EventEmitter<void>();
  private readonly imagesSrc$: Observable<string[]> = of([
    `${environment.wizbiiImages}/homeB/hero/blue.jpg`,
    `${environment.wizbiiImages}/homeB/hero/red.jpg`,
    `${environment.wizbiiImages}/homeB/hero/brown.jpg`,
    `${environment.wizbiiImages}/homeB/hero/green.jpg`,
    `${environment.wizbiiImages}/homeB/hero/pink.jpg`,
    `${environment.wizbiiImages}/homeB/hero/orange.jpg`,
  ]);

  illustrations$!: Observable<string[]>;

  trackEvent = trackEventWithAtInternet;
  HomeBRoute = FeaturesRoutingEnum.HomeB;

  readonly FeaturesRoutingEnum = FeaturesRoutingEnum;

  ngOnInit(): void {
    this.illustrations$ = combineLatest(this.imagesSrc$, this.breakpointsService.isMobile$).pipe(
      map(([illustrations, isMobile]) => {
        if (isMobile) {
          return [];
        }
        return Array.from({ length: 3 }).map(() => {
          const randomInt = this.getRandomInt(illustrations.length);
          const illustration = illustrations[randomInt];
          illustrations.splice(randomInt, 1);
          return illustration;
        });
      })
    );
  }

  goToYoungSection(): void {
    this.trackEvent({ category: 'Home', action: 'Click Jeunes', type: 'navigation' });
    this.document.getElementById('jeunes')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'center',
    });
  }

  goToEmployerSection(): void {
    this.trackEvent({ category: 'Home', action: 'Click Employeurs', type: 'navigation' });
    this.onGoToEmployersSectionClick.emit();
    this.document.getElementById('employeurs')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'center',
    });
  }

  trackByIllustration(_: number, illustration: string): string {
    return illustration;
  }

  constructor(
    private readonly breakpointsService: BreakpointsService,
    @Inject(DOCUMENT) private readonly document: any
  ) {}

  private getRandomInt(max: number): number {
    return Math.floor(Math.random() * Math.floor(max));
  }
}

@NgModule({
  declarations: [HomeBHeroComponent],
  imports: [CommonModule, ImaginarySrcModule, ScrollToModule, RouterModule],
  exports: [HomeBHeroComponent],
})
export class HomeBHeroModule {}
